module.exports = __webpack_public_path__ + "img/noveler.9c0d4565.png";